export class PlantIdRequest{
    plantId?: number;
    role?: string;
    varientId?: number;
    stockType?:string
}

export class StockInReverseReq{
    plantId: number;
    varientId?: number;
    saleOrderId?:number;
    fromDate?:Date;
    toDate?:Date;
}